export enum PreguntasTipoEnum { SINGLE_CHOICE = 1, MULTIPLE_CHOICE = 3, NUMERIC_IN_RANGE, TEXT, VIDEO, URL, PICTURE,
    INFO = 11, NUMERIC_TEXT, MATRIX_SINGLE, MATRIX_MULTIPLE, MATRIX_RANGE, DISTRIBUTION = 17, EXTRA_POINTS,
    NET_PROMOTER_SCORE, DATE_SELECT, RANKING, SCANNER, GRAPHICAL_CHOICE,

    FLOW_CHECKPOINT = 100, FLOW_GROUP, FLOW_JUMP, FLOW_RANDOM, FLOW_CODE,

    ITEM_MATCH = 1000, RESULTADO, DESPLEGABLE, SLIDER_TEXT, SIYNO }

export enum SingleSubtipoEnum { REGULAR, SINGLE_STATS, SINGLE_COMBO, SINGLE_SLIDER, SINGLE_TEXT }
export enum MultipleSubtipoEnum { REGULAR, YESNO }
export enum NPSSubtipoEnum { SPINNER, LIST, SLIDER }

export type Subtipo = SingleSubtipoEnum | MultipleSubtipoEnum | NPSSubtipoEnum;
export type TiposConSubtipo = PreguntasTipoEnum.SINGLE_CHOICE | PreguntasTipoEnum.MULTIPLE_CHOICE;

const idsPreguntasTipo = new Map<PreguntasTipoEnum, string>();
idsPreguntasTipo.set(PreguntasTipoEnum.SINGLE_CHOICE, "SINGLE_CHOICE");
idsPreguntasTipo.set(PreguntasTipoEnum.MULTIPLE_CHOICE, "MULTIPLE_CHOICE");
idsPreguntasTipo.set(PreguntasTipoEnum.NUMERIC_IN_RANGE, "NUMERIC_IN_RANGE");
idsPreguntasTipo.set(PreguntasTipoEnum.TEXT, "TEXT");
idsPreguntasTipo.set(PreguntasTipoEnum.VIDEO, "VIDEO");
idsPreguntasTipo.set(PreguntasTipoEnum.URL, "URL");
idsPreguntasTipo.set(PreguntasTipoEnum.PICTURE, "PICTURE");
idsPreguntasTipo.set(PreguntasTipoEnum.INFO, "INFO");
idsPreguntasTipo.set(PreguntasTipoEnum.NUMERIC_TEXT, "NUMERIC_TEXT");
idsPreguntasTipo.set(PreguntasTipoEnum.MATRIX_SINGLE, "MATRIX_SINGLE");
idsPreguntasTipo.set(PreguntasTipoEnum.MATRIX_MULTIPLE, "MATRIX_MULTIPLE");
idsPreguntasTipo.set(PreguntasTipoEnum.MATRIX_RANGE, "MATRIX_RANGE");
idsPreguntasTipo.set(PreguntasTipoEnum.DISTRIBUTION, "DISTRIBUTION");
idsPreguntasTipo.set(PreguntasTipoEnum.EXTRA_POINTS, "EXTRA_POINTS");
idsPreguntasTipo.set(PreguntasTipoEnum.NET_PROMOTER_SCORE, "NET_PROMOTER_SCORE");
idsPreguntasTipo.set(PreguntasTipoEnum.DATE_SELECT, "DATE_SELECT");
idsPreguntasTipo.set(PreguntasTipoEnum.RANKING, "RANKING");
idsPreguntasTipo.set(PreguntasTipoEnum.FLOW_CHECKPOINT, "FLOW_CHECKPOINT");
idsPreguntasTipo.set(PreguntasTipoEnum.FLOW_GROUP, "FLOW_GROUP");
idsPreguntasTipo.set(PreguntasTipoEnum.FLOW_JUMP, "FLOW_JUMP");
idsPreguntasTipo.set(PreguntasTipoEnum.FLOW_RANDOM, "FLOW_RANDOM");
idsPreguntasTipo.set(PreguntasTipoEnum.FLOW_CODE, "FLOW_CODE");
idsPreguntasTipo.set(PreguntasTipoEnum.SCANNER, "SCANNER");
idsPreguntasTipo.set(PreguntasTipoEnum.ITEM_MATCH, "ITEM_MATCH");
idsPreguntasTipo.set(PreguntasTipoEnum.GRAPHICAL_CHOICE, "GRAPHICAL_CHOICE");

const nombresPreguntasTipo = new Map<PreguntasTipoEnum, string>();
nombresPreguntasTipo.set(PreguntasTipoEnum.SINGLE_CHOICE, "Single");
nombresPreguntasTipo.set(PreguntasTipoEnum.MULTIPLE_CHOICE, "Múltiple");
nombresPreguntasTipo.set(PreguntasTipoEnum.NUMERIC_IN_RANGE, "Rango");
nombresPreguntasTipo.set(PreguntasTipoEnum.TEXT, "Texto libre");
nombresPreguntasTipo.set(PreguntasTipoEnum.VIDEO, "Video");
nombresPreguntasTipo.set(PreguntasTipoEnum.URL, "URL");
nombresPreguntasTipo.set(PreguntasTipoEnum.PICTURE, "Picture");
nombresPreguntasTipo.set(PreguntasTipoEnum.INFO, "Info");
nombresPreguntasTipo.set(PreguntasTipoEnum.NUMERIC_TEXT, "Texto Numérico");
nombresPreguntasTipo.set(PreguntasTipoEnum.MATRIX_SINGLE, "Matriz single");
nombresPreguntasTipo.set(PreguntasTipoEnum.MATRIX_MULTIPLE, "Matriz multiple");
nombresPreguntasTipo.set(PreguntasTipoEnum.MATRIX_RANGE, "Matriz rango");
nombresPreguntasTipo.set(PreguntasTipoEnum.DISTRIBUTION, "Distribución");
nombresPreguntasTipo.set(PreguntasTipoEnum.EXTRA_POINTS, "Puntos extra");
nombresPreguntasTipo.set(PreguntasTipoEnum.NET_PROMOTER_SCORE, "NET_PROMOTER_SCORE");
nombresPreguntasTipo.set(PreguntasTipoEnum.DATE_SELECT, "Seleccion de fecha");
nombresPreguntasTipo.set(PreguntasTipoEnum.RANKING, "Ranking");
nombresPreguntasTipo.set(PreguntasTipoEnum.FLOW_CHECKPOINT, "Checkpoint");
nombresPreguntasTipo.set(PreguntasTipoEnum.FLOW_GROUP, "Bloque");
nombresPreguntasTipo.set(PreguntasTipoEnum.FLOW_JUMP, "Salto Condicionado");
nombresPreguntasTipo.set(PreguntasTipoEnum.FLOW_RANDOM, "Derivador Random");
nombresPreguntasTipo.set(PreguntasTipoEnum.FLOW_CODE, "Codigo");
nombresPreguntasTipo.set(PreguntasTipoEnum.SCANNER, "Scanner");
nombresPreguntasTipo.set(PreguntasTipoEnum.ITEM_MATCH, "Item Match");
nombresPreguntasTipo.set(PreguntasTipoEnum.RESULTADO, "Resultado");
nombresPreguntasTipo.set(PreguntasTipoEnum.DESPLEGABLE, "Desplegable");
nombresPreguntasTipo.set(PreguntasTipoEnum.SLIDER_TEXT, "Slider Text");
nombresPreguntasTipo.set(PreguntasTipoEnum.SIYNO, "Si/No");
nombresPreguntasTipo.set(PreguntasTipoEnum.GRAPHICAL_CHOICE, "Seleccion Imagenes");

const activosPreguntasTipo = [PreguntasTipoEnum.SINGLE_CHOICE, PreguntasTipoEnum.MULTIPLE_CHOICE,
    PreguntasTipoEnum.NUMERIC_IN_RANGE, PreguntasTipoEnum.TEXT, PreguntasTipoEnum.NUMERIC_TEXT, PreguntasTipoEnum.URL,
    PreguntasTipoEnum.VIDEO, PreguntasTipoEnum.PICTURE, PreguntasTipoEnum.INFO, PreguntasTipoEnum.MATRIX_SINGLE,
    PreguntasTipoEnum.MATRIX_MULTIPLE, PreguntasTipoEnum.MATRIX_RANGE, PreguntasTipoEnum.EXTRA_POINTS,
    PreguntasTipoEnum.DATE_SELECT, PreguntasTipoEnum.RANKING, PreguntasTipoEnum.FLOW_CHECKPOINT,
    PreguntasTipoEnum.FLOW_GROUP, PreguntasTipoEnum.FLOW_JUMP, PreguntasTipoEnum.FLOW_RANDOM,
    PreguntasTipoEnum.DISTRIBUTION, PreguntasTipoEnum.GRAPHICAL_CHOICE];

const nombresSingleSubtipo = new Map<SingleSubtipoEnum, string>();
const nombresMultiplesSubtipo = new Map<MultipleSubtipoEnum, string>();
const nombresNPSSubtipo = new Map<NPSSubtipoEnum, string>();
nombresSingleSubtipo.set(SingleSubtipoEnum.REGULAR, "Normal");
nombresSingleSubtipo.set(SingleSubtipoEnum.SINGLE_STATS, "Resultado");
nombresSingleSubtipo.set(SingleSubtipoEnum.SINGLE_COMBO, "Desplegable");
nombresSingleSubtipo.set(SingleSubtipoEnum.SINGLE_SLIDER, "Slider text");
nombresSingleSubtipo.set(SingleSubtipoEnum.SINGLE_TEXT, "Item match");
nombresMultiplesSubtipo.set(MultipleSubtipoEnum.REGULAR, "Normal");
nombresMultiplesSubtipo.set(MultipleSubtipoEnum.YESNO, "Si/No");
nombresNPSSubtipo.set(NPSSubtipoEnum.SPINNER, "SPINNER");
nombresNPSSubtipo.set(NPSSubtipoEnum.LIST, "LIST");
nombresNPSSubtipo.set(NPSSubtipoEnum.SLIDER, "SLIDER");
const nombresPreguntasSubtipo = new Map<PreguntasTipoEnum, Map<Subtipo, string>>();
nombresPreguntasSubtipo.set(PreguntasTipoEnum.SINGLE_CHOICE, nombresSingleSubtipo);
nombresPreguntasSubtipo.set(PreguntasTipoEnum.MULTIPLE_CHOICE, nombresMultiplesSubtipo);
nombresPreguntasSubtipo.set(PreguntasTipoEnum.NET_PROMOTER_SCORE, nombresNPSSubtipo);

export const obtenerIdPreguntaTipo: (tipo: PreguntasTipoEnum) => string = tipo =>
    idsPreguntasTipo.get(tipo) ?? "";
export const obtenerNombrePreguntaTipo: (tipo: PreguntasTipoEnum) => string = tipo =>
    nombresPreguntasTipo.get(tipo) ?? "";

export const obtenerIdsPreguntaTipo: () => Array<[PreguntasTipoEnum, string]> =
    () => Array.from(idsPreguntasTipo.entries());
export const estaActivaPreguntaTipo: (tipo: PreguntasTipoEnum) => boolean = tipo =>
    activosPreguntasTipo.includes(tipo);
export const obtenerNombresPreguntaSubtipo: (tipo: TiposConSubtipo) => Array<[Subtipo, string]> =
    (tipo) => Array.from(nombresPreguntasSubtipo.get(tipo)!.entries());
